import AgentesList from './AgentesList'
import AgenteEdit from './AgentesEdit'

export default {
  list: AgentesList,
  edit: AgenteEdit,
}
